module.exports = __webpack_public_path__ + "img/imago-prosegur@2x.cfe84cef.png";